export default class CustomMotifRequest {
  typeId;
  customMotifInputs;

  constructor(typeId, customMotifInputs) {
    this.typeId = typeId;
    this.motifInputs = customMotifInputs;
  }
}
